import { environment } from "../../environments/environment";

const PAYMENT_API_BASE_URL = environment.application.api_base_payment_url;

function paymentApiUrl(endpoint: string) {
    return `${PAYMENT_API_BASE_URL}${endpoint}`;
}

export const paymentApiAsset = {
    getPaymentSession: paymentApiUrl("TextToPay/GetSessionToken"),
    createPayment: paymentApiUrl("TextToPay/ProcessPayment"),
    getInvoiceResponse: paymentApiUrl("TextToPay/GetTextToPayDetails"),
}
